<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row align="center" justify="center">
    <v-card class="pa-3" width="100%">
      <v-form ref="form" v-model="valid" lazy-validation>
        <!--                Header cover video-->
        <v-col>
          <!-- Cover -->
          <v-row class="text-xs-center">
            <v-row wrap fill-height>
              <FileInput
                @file-selected="imageSelected"
                @file-uploaded="imageUploaded"
                @file-picked="imagePicked"
                :url="article.cover.url"
                :upload="isEdit"
              >
              </FileInput>
            </v-row>
          </v-row>

          <!-- Video -->
          <!--          <v-row align="center" justify="center" align-content="center">-->
          <!--            <v-col v-if="isEdit && videoUrl">-->
          <!--              <youtube-->
          <!--                style="margin: 0 auto"-->
          <!--                v-show="videoId"-->
          <!--                :video-id="videoId"-->
          <!--                :player-vars="{ controls: 0, showinfo: 0, frameborder: 0 }"-->
          <!--              ></youtube>-->
          <!--              <v-btn dark color="warning" class="text-lg-right" @click="removeVideo">-->
          <!--                Удалить видео-->
          <!--                <v-icon dark>mdi-close</v-icon>-->
          <!--              </v-btn>-->
          <!--            </v-col>-->
          <!--          </v-row>-->
          <!--          <v-row>-->
          <!--            <v-col cols="12">-->
          <!--              <v-text-field-->
          <!--                v-if="!isEdit || (isEdit && !videoUrl)"-->
          <!--                v-model="videoUrl"-->
          <!--                label="Видео"-->
          <!--                name="video_url"-->
          <!--                required-->
          <!--              ></v-text-field>-->
          <!--            </v-col>-->
          <!--          </v-row>-->

          <v-col grow d-flex cols="12">
            <v-text-field
              v-model="article.title"
              name="title"
              :counter="100"
              label="Заголовок"
              required
              :rules="notEmptyRules"
            ></v-text-field>
          </v-col>
          <v-col xs12 cols="12" class="text-lg-center" aling-self-center>
            <v-row row>
              <v-col lg6 sm12>
                <SiteSelect
                  :site="isEdit ? article.site_key : $attrs.site_key"
                  @site-selected="siteSelected"
                ></SiteSelect>
              </v-col>
            </v-row>
          </v-col>

          <!--Dates-->
          <v-col cols="12">
            <v-row row>
              <v-col xs12 sm6 md4>
                <v-menu
                  ref="dateMenu"
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="article.date"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="article.date"
                      prepend-icon="event"
                      readonly
                      name="date"
                      :rules="notEmptyRules"
                      v-on="on"
                    >
                      <template v-slot:label>
                        <span class="" :class="{ 'red--text': isForTheFeature }">{{
                          dateLabel
                        }}</span>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="article.date" locale="ru-ru" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dateMenu = false">Отменить</v-btn>
                    <v-btn text color="primary" @click="$refs.dateMenu.save(article.date)">
                      Выбрать
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col offset-lg1 xs12 sm6 md4>
                <v-row row>
                  <v-col lg4>
                    <v-switch
                      color="green"
                      v-model="article.is_announce"
                      name="is_announce"
                      label="Отметить как анонс"
                    ></v-switch>
                  </v-col>

                  <v-slide-x-transition>
                    <v-col lg8 v-show="article.is_announce">
                      <v-menu
                        ref="announceMenu"
                        v-model="announceMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="article.announce_date"
                        name="announce_date"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="article.announce_date"
                            label="Выбрать дату ананонса"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="article.announce_date"
                          locale="ru-ru"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="announceMenu = false">
                            Отменить
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.announceMenu.save(article.announce_date)"
                          >
                            Выбрать
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-slide-x-transition>
                </v-row>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <ckeditor
              :editor="ckeditor"
              v-model="article.content"
              :config="ckConfig"
              type="classic"
              :upload-adapter="UploadAdapter"
              @ready="setUploader"
            >
            </ckeditor>
            <input type="text" name="content" v-model="article.content" hidden />
          </v-col>

          <v-col cols="12" v-if="isEdit">
            <v-combobox
              ref="tagsCombobox"
              v-model="article.tags"
              multiple
              persistent-hint
              small-chips
              cache-items
              label="Тэги"
              @change="changeTagInput"
              @input="tagInput"
              deletable-chips
              name="tags"
              :items="searchTags"
              :search-input.sync="searchTag"
            >
            </v-combobox>
          </v-col>
          <v-col cols="12">
            <v-row justify="start" v-if="isEdit">
              <v-col sm3>
                <v-switch
                  :disabled="!hasPublishPermission && !isEditor && !isSuperuser"
                  color="green"
                  v-model="article.published"
                  name="published"
                  label="Опубликовать"
                ></v-switch>
              </v-col>
              <v-col sm3>
                <v-switch
                  :disabled="!hasPermissionToEdit"
                  color="green"
                  v-model="article.is_common"
                  name="is_common"
                  label="На федеральный"
                ></v-switch>
              </v-col>
              <v-col sm3>
                <v-switch
                  :disabled="!hasPermissionToEdit"
                  color="green"
                  v-model="article.in_digest"
                  name="in_digest"
                  label="В дайджест"
                ></v-switch>
              </v-col>
              <v-col sm3>
                <v-switch
                  :disabled="!hasPermissionToEdit"
                  color="green"
                  v-model="article.reviewed"
                  label="Просмотрено"
                ></v-switch>
              </v-col>
              <v-col sm3>
                <v-switch
                  :disabled="!hasPublishPermission"
                  color="green"
                  v-model="article.is_main_banner_35_ldpr"
                  label="В баннер 35 лет ЛДПР"
                ></v-switch>
              </v-col>
              <v-col sm3>
                <v-switch
                  :disabled="!hasPublishPermission"
                  color="green"
                  v-model="article.is_35_ldpr"
                  label="В ленту 35 лет ЛДПР"
                ></v-switch>
              </v-col>
              <v-col sm3>
                <v-switch
                  :disabled="!hasPublishPermission"
                  color="green"
                  v-model="article.is_main_banner_shoulder"
                  label="В баннер Плечом к плечу."
                ></v-switch>
              </v-col>
              <v-col sm3>
                <v-switch
                  :disabled="!hasPublishPermission"
                  color="green"
                  v-model="article.is_shoulder"
                  label="В ленту Плечом к плечу."
                ></v-switch>
              </v-col>
              <v-col sm6>
                <div class="text-xs-center">
                  <v-rating
                    hover
                    label="Приоритет"
                    length="4"
                    v-model="article.priority"
                    name="priority"
                  ></v-rating>
                  Приоритет
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-col>
        <!--                    End header-->

        <v-row row justify-beetwen-space>
          <v-col lg6 class="text-lg-center">
            <v-btn color="success" @click="submit" :loading="loading">Сохранить</v-btn>
          </v-col>
          <v-col v-if="isEdit" lg6 class="text-lg-center">
            <v-btn color="error" @click="deleteDialog = true">Удалить</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <DeleteDialog
      v-if="isEdit"
      :title="article.title"
      :active="deleteDialog"
      @remove="deleteArticle"
      @cancel="deleteDialog = false"
    >
    </DeleteDialog>
  </v-row>
</template>

<script>
// TODO: make me better
import FileInput from '@/components/FileInput'
import SiteSelect from '@/components/SiteSelect'
import ckeditorMixin from '@/mixins/ckeditor'
import utils from '@/mixins/utils'
import user from '@/mixins/user'
import DeleteDialog from '@/components/DeleteDialog'

export default {
  name: 'ArticleCreateUpdate',
  components: { SiteSelect, FileInput, DeleteDialog },
  mixins: [ckeditorMixin, utils, user],
  data() {
    return {
      valid: false,
      dateMenu: false,
      announceMenu: false,
      loading: false,
      searchTag: '',
      searchTags: [],
      lazySearchTag: '',
      tags: [],
      article: {
        cover: { url: '' },
        links: [],
        tags: [],
        keywords: [],
        video: { url: '' },
        site_key: '',
        is_common: false,
        is_announce: false,
        in_digest: false,
        is_main_banner_35_ldpr: false,
        is_35_ldpr: false,
        is_main_banner_shoulder: false,
        is_shoulder: false,
        announce_date: '',
      },
      notEmptyRules: [(v) => !!v || 'Это поле обязательно'],
      videoUrl: '',
      deleteDialog: false,
    }
  },
  computed: {
    hasPermissionToEdit() {
      return this.isEditor || this.isSuperuser
    },
    articleDate: {
      get() {
        return this.$moment(this.article.date).format('LL')
      },
      set(a) {
        this.article.date = a
      },
    },
    isEdit() {
      return this.$route.name === 'article_edit' && this.$route.params.id > 0
    },
    videoId() {
      return this.getVideoId(this.videoUrl)
    },
    isForTheFeature() {
      return this.$moment(this.article.date) > this.$moment()
    },
    dateLabel() {
      const aDate = this.$moment(this.article.date)
      const strDate = aDate.format('LL')
      let s = `${strDate}`

      if (aDate > this.$moment()) {
        s = `будет опубликовано не ранее ${s}`
      }
      return s
    },
  },
  watch: {
    searchTag(e) {
      if (e && e.trim()) {
        this.axios({ url: '/v1/tags/list', method: 'get', params: { q: e.trim() } })
          .then((resp) => {
            if (!resp.data) {
              this.searchTags = []
              return
            }
            for (let i in resp.data) {
              this.searchTags.push(resp.data[i].name)
            }
          })
          .catch((err) => {
            this.$log.error('search tag', e, err)
            this.showSnackbar(err.response.data, 'error')
          })
      }
    },
  },
  created() {
    if (this.isEdit) {
      this.getArticle()
    } else {
      this.article.reviewed = true
    }
    // this.getTags()
  },
  methods: {
    setUploader(editor) {
      editor.plugins.get('FileRepository').createUploadAdapter = (loader) =>
        new this.UploadAdapter(loader)
    },
    getTags() {
      this.axios({ url: '/v1/tags/list', method: 'get' })
        .then((resp) => {
          for (let i in resp.data) {
            this.searchTags.push(resp.data[i].name)
          }
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    tagInput(e) {
      this.$log.debug('input tag', e)
    },
    removeVideo() {
      if (!this.isEdit || !this.article.video) {
        return
      }
      this.axios({
        url: `/v1/articles/${this.article.id}/video`,
        method: 'delete',
      })
        .then(() => {
          this.videoUrl = ''
          this.article.video = ''
          this.$log.debug('video deleted')
        })
        .catch((err) => {
          this.$log.error('video delete', err.response)
        })
    },
    changeTagInput() {
      this.searchTag = ''
      if (this.isEdit) {
        this.article.tags = this._.remove(this.article.tags, (n) => {
          return n.trim() !== ''
        })
        let tags = []

        // Delete if needed or added to temp array
        for (let i = 0; i < this.tags.length; i++) {
          // Trim spaces
          let tag = this.tags[i].trim()
          if (!this.article.tags.includes(tag)) {
            this.$log.debug('tag for delete', tag)
            this.axios({
              url: `/v1/articles/${this.$route.params.id}/tags/${tag}`,
              method: 'delete',
            })
              .then((resp) => {
                this.$log.debug('tag deleted', resp.status)
                this.showSnackbar(`тэг ${tag} удален`, 'green', 2000)
              })
              .catch((err) => {
                this.$log.error('tag delete', err.response.data)
                this.showSnackbar(err.response ? err.response.data : err, 'error')
              })
          } else {
            tags.push(tag)
          }
        }

        this.tags = tags
        let tagsCount = this.article.tags.length
        let forExclude = []
        let regexp = /(#|\/|\\)/g
        for (let i = 0; i < this.article.tags.length; i++) {
          let tag = this.article.tags[i].trim()
          tag = tag.replace(regexp, '')
          this.$log.debug('tag', tag)
          if (!tag || this.tags.includes(tag)) {
            continue
          }
          if (tagsCount >= 6) {
            forExclude.push(tag)
            this.showSnackbar(
              `тэг ${tag} не будет добавлен, так как превышен лимит количества тэгов`,
              'error'
            )
            continue
          }
          this.$log.debug('tag for create', tag)
          this.axios({
            url: `/v1/articles/${this.$route.params.id}/tags`,
            method: 'post',
            data: [tag],
          })
            .then((resp) => {
              this.$log.debug('tag create', resp.data)
              this.tags.push(tag)
              this.showSnackbar(`тэг ${tag} добавлен`, 'green')
            })
            .catch((err) => {
              this.$log.error('tag create', err)
              this.showSnackbar(err.response ? err.response.data : err, 'error')
            })
        }
        this.article.tags = this._.remove(this.article.tags, (n) => {
          return !forExclude.includes(n.trim())
        })
      }
    },
    imageSelected(e) {
      this.$log.debug('image select ', e)
      this.article.cover = e
      this.article.cover_id = e.id || 0
      if (!this.isEdit) {
        this.loading = false
      }
    },
    imageUploaded(e) {
      this.$log.debug('image uploaded ', e)
      this.article.cover = e
      this.article.cover_id = e.id || 0
      if (this.isEdit) {
        this.loading = false
      }
    },
    imagePicked() {
      this.loading = true
    },
    siteSelected(e) {
      this.article.site_key = e.key
    },
    getArticle() {
      this.axios({
        url: `/v1/articles/${this.$route.params.id}`,
        method: 'get',
        params: { full: 'true' },
      })
        .then((resp) => {
          this.article = resp.data
          this.tags = this.article.tags || []
          this.videoUrl = this.article.video && this.article.video.url ? this.article.video.url : ''
          this.article.cover = this.article.cover ? this.article.cover : { url: '' }
        })
        .catch(() => {
          this.showSnackbar('Ошибка загрузки, попробуйте перезагрузить страницу', 'error')
        })
    },
    submit() {
      this.loading = true
      if (this.isEdit) {
        return this.updateArticle()
      } else {
        this.saveArticle()
      }
      this.loading = false
    },
    saveArticle() {
      if (!this.$refs.form.validate()) {
        this.$log.debug('form', this.$refs.form)
        this.showSnackbar('Заполните все поля', 'error')
        return
      }
      this.loading = true
      const form = this.$refs.form.$el
      const data = new FormData(form)
      // data.set('date', this.article.date)
      this.axios({
        url: `/v1/articles`,
        method: 'post',
        data: data,
      })
        .then((resp) => {
          this.article = resp.data
          this.tags = this.article.tags || []
          this.showSnackbar('Сохранено', 'green')
          this.$router.push({ name: 'article_edit', params: { id: resp.data.id } })
        })
        .catch((err) => {
          this.$log.error(err.response ? err.response.data : err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
        .finally(() => (this.loading = false))
    },
    updateArticle() {
      let article = this.article
      this.loading = true
      article.video = this.videoUrl
      this.axios({
        url: `/v1/articles/${this.article.id}`,
        params: { full: 'true' },
        method: 'post',
        data: article,
      })
        .then((resp) => {
          this.article = resp.data
          this.tags = this.article.tags || []
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.$log.error(err)
          this.showSnackbar(err.response ? err.response.data.message : err, 'error')
        })
        .finally(() => (this.loading = false))
    },
    deleteArticle() {
      if (!this.isEdit) {
        return
      }
      this.axios({
        url: `/v1/articles/${this.$route.params.id}`,
        method: 'delete',
      })
        .then(() => {
          this.$router.push({ name: 'articles' })
          this.showSnackbar('Удалено', 'green')
        })
        .catch((err) => {
          this.$log.error('error delete', err.response)
          this.showSnackbar(err.response.data.message, 'error')
        })
        .finally(() => {
          this.deleteDialog = false
        })
    },
  },
}
</script>

<style lang="scss">
.cover {
  background-position: center;
}
</style>
